import z from "zod";
import { relationSelectOptionSchema } from "view/relations/utils/relation.schema";

export const termsSchema = z.object({
	id: z.number().nullable(),
	description: z.string().min(1).max(255),
	debtor: relationSelectOptionSchema.nullable(),
});

export type TermsSchemaInput = z.input<typeof termsSchema>;
export type TermsSchemaOutput = z.output<typeof termsSchema>;
